import { Component, Input, OnInit } from '@angular/core';
// Forms
import { FormGroup, FormGroupDirective} from '@angular/forms';
// Models
import { OrganizationTypeEnum, getOrganizationTypeLabel } from '@mocca-technologies/model';

@Component({
  selector: 'app-operator-info',
  templateUrl: './operator-info.component.html',
  styleUrls: ['./operator-info.component.scss'],
})
export class OperatorInfoComponent  implements OnInit {

  /**
   * Variables
   */
  OperatorForm: FormGroup;
  operatorTypes = Object.values(OrganizationTypeEnum);

  /**
   * Input parameters
   */
  @Input() isSubOperator: boolean = false;

  /**
   * Functions
   */
  getOrganizationTypeLabel = getOrganizationTypeLabel

  constructor(private rootFormGroup: FormGroupDirective) {}

  // #region --> LifeCycle

  /**
   * Every time the component is rendered, we take from the parent the vehicle form.
   */
  ngOnInit() {
    this.OperatorForm = this.rootFormGroup.control;
  }

  // #endregion --> LifeCycle

}

